import { render, staticRenderFns } from "./TextBubble.vue?vue&type=template&id=857f801c&scoped=true&"
import script from "./TextBubble.vue?vue&type=script&lang=js&"
export * from "./TextBubble.vue?vue&type=script&lang=js&"
import style0 from "./TextBubble.vue?vue&type=style&index=0&id=857f801c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857f801c",
  null
  
)

export default component.exports